import { defineMessages } from 'react-intl';

export const wizardInsuranceFooterMessages = defineMessages({
  insureThisShipment: {
    defaultMessage: 'Insure this shipment',
    id: 'fHqxhC',
    description: 'Label for the insurance toggle in the rates panel footer',
  },
  edit: {
    defaultMessage: 'Edit',
    id: 'vUVzGg',
    description: 'Button to open the insurance edit form in the rates panel footer',
  },
  summaryInsuredValueLabel: {
    defaultMessage: 'Insured Value:',
    id: 'B0MveU',
    description: 'Inline label preceding the insured value amount in the collapsed insurance summary',
  },
});
